import * as $ from "jquery";
import { Subject } from "rxjs";
import {timeout} from "rxjs/operator/timeout";

const ReCaptcha_Key = "6Lcbfk0UAAAAAIP7DZbkxEAbVhqPjLzSwkX4QsFl";

export class RecaptchaService {
  captchaReadySubject: Subject<boolean> = new Subject<boolean>();

  public static setupRecaptcha() {
    (self as any).onloadCallback = function () {
      RecaptchaService.initCaptchas();
    };
    $(".captcha-container").each((i, cont) => {
      $(cont).html('');
    });
  }

  public static initCaptchas() {
    $(".captcha-container").each((i, cont) => {
      setTimeout(function () {
        RecaptchaService.initRecaptcha(cont);
      }, 200);

    });
  }

  public static reset() {
    try {
      (self as any).grecaptcha.reset()
    }
    catch (ex) { } //in case no recaptchha client exist
  }

  public static initRecaptcha(cont) {
    if ((self as any).grecaptcha.render && $(cont).html() == '') {
      (self as any).grecaptcha.render(cont, {
        sitekey: ReCaptcha_Key,
        callback: response => {
          let hidden = $(cont)
            .parent()
            .find("input[type=hidden]");
          hidden.attr("data-dirty", "true");
          //server-side validation step!!
          RecaptchaService.verify(response).done(resp => {
            if (resp.toString() === "true") {
              hidden.val("true");
              $('input').blur(); //refresh validation
            }
          });
        }
      });
    }
  }

  public static verify(token) {
    return $.get(`/verifyCaptcha?g-recaptcha-response=${token}`);
  }
}
